import React from 'react';
import { useFeatureContext } from 'context/FeaturesContext/FeaturesContext';
import { FeatureSwitch } from 'components/V1/Feature/Feature';

export const V2_FLAG = 'v2_flag';

/** True when the v2 UI shell is enabled. Must be called inside a FeaturesProvider. */
export function useIsV2() {
  return useFeatureContext(V2_FLAG);
}

interface V2SwitchProps {
  readonly children: React.ReactNode;
}

/**
 * Functions similarly to a Features switch
 *
 *   <V2Switch>
 *     <V2Switch.New>
 *       <SideNavV2 />
 *     </V2Switch.New>
 *     <V2Switch.Old>
 *       <SideNav />
 *     </V2Switch.Old>
 *   </V2Switch>
 *
 * A shell piece with no v2 implementation yet simply has no `V2Switch.New`
 * branch, so it keeps rendering the v1 version under both flag states.
 */
export function V2Switch({ children }: V2SwitchProps) {
  return <FeatureSwitch flag={V2_FLAG}>{children}</FeatureSwitch>;
}

V2Switch.New = FeatureSwitch.On;
V2Switch.Old = FeatureSwitch.Off;

export default V2Switch;
